module.exports = __webpack_public_path__ + "static/media/crohns3.7990e955.jpg";